import React from "react";
import { useT } from "@/i18n/LanguageContext";
import SectionHeading from "@/components/SectionHeading";
import Disclaimer from "@/components/Disclaimer";
import { ShieldCheck, FileSearch, Scale, X } from "lucide-react";

const About = () => {
  const { t, lang } = useT();
  const icons = [ShieldCheck, FileSearch, Scale];
  return (
    <div className="mx-auto max-w-5xl px-4 md:px-8 py-16 md:py-24" data-testid="about-page">
      <SectionHeading eyebrow="Our Mission" title={t.about.title} subtitle={t.about.subtitle} />

      <div className="mt-10 surface-card p-7 md:p-10">
        <p className={`text-lg text-white/80 leading-relaxed ${lang === "hi" ? "lang-hi" : ""}`}>{t.about.mission}</p>
      </div>

      <div className="mt-14">
        <div className="text-xs uppercase tracking-widest text-[#D4AF37] font-mono-alt">Core Pillars of Integrity</div>
        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-5">
          {t.about.pillars.map((p, i) => {
            const Icon = icons[i];
            return (
              <div key={p.title} className="surface-card p-6" data-testid={`pillar-${i}`}>
                <div className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-[#D4AF37]/10 text-[#D4AF37] ring-1 ring-[#D4AF37]/30">
                  <Icon className="h-5 w-5" />
                </div>
                <div className={`mt-5 font-display text-lg font-bold ${lang === "hi" ? "lang-hi" : ""}`}>{p.title}</div>
                <div className={`mt-2 text-sm text-white/65 leading-relaxed ${lang === "hi" ? "lang-hi" : ""}`}>{p.desc}</div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="mt-16 rounded-xl border border-[#FF3B30]/30 bg-[#FF3B30]/[0.04] p-7">
        <div className={`font-display text-xl font-bold ${lang === "hi" ? "lang-hi" : ""}`}>{t.about.notDo.title}</div>
        <ul className="mt-4 space-y-2">
          {t.about.notDo.items.map((it, i) => (
            <li key={i} className={`flex items-start gap-3 text-sm text-white/80 ${lang === "hi" ? "lang-hi" : ""}`}>
              <X className="h-4 w-4 text-[#FF3B30] mt-0.5 flex-shrink-0" />
              <span>{it}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-14">
        <Disclaimer
          text={t.about.disclaimer || "CHINTAMAT is not a law firm and not a financial advisor. We guide victims toward official Indian complaint systems."}
          variant="alert"
        />
      </div>
    </div>
  );
};

export default About;
